var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinLock = function SvgPinLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140.777,
    height: 132.777,
    viewBox: "0 0 140.777 132.777",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18577",
    "data-name": "Group 18577",
    transform: "translate(-315 -648.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14186",
    "data-name": "Group 14186",
    transform: "translate(315 648.23)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_857",
    "data-name": "Ellipse 857",
    cx: 61.569,
    cy: 57.568,
    rx: 61.569,
    ry: 57.568,
    transform: "translate(8.388 8.39)",
    fill: "#bcf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_25",
    "data-name": "Subtraction 25",
    d: "M6.67,50.031H0V28.768a28.775,28.775,0,0,1,55.274-11.2,28.588,28.588,0,0,1,2.261,11.2V50.029H50.864V28.768a22.1,22.1,0,1,0-44.194,0V50.03Z",
    transform: "translate(42.02 23.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_26",
    "data-name": "Intersection 26",
    d: "M36.618,62.538A72.54,72.54,0,0,1,0,49.324V10A10,10,0,0,1,10,0H76.381a10,10,0,0,1,10,10V48.566A72.412,72.412,0,0,1,48.729,62.538Z",
    transform: "translate(27.142 60.77)",
    fill: "#fec95f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_859",
    "data-name": "Ellipse 859",
    cx: 7.505,
    cy: 7.505,
    rx: 7.505,
    ry: 7.505,
    transform: "translate(62.824 79.114)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9295",
    "data-name": "Path 9295",
    d: "M-10700.633-19293l-4.172,13.234h14l-3.5-13.234Z",
    transform: "translate(10767.773 19385.459)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8244",
    "data-name": "Rectangle 8244",
    width: 4.825,
    height: 31.686,
    rx: 2.412,
    transform: "translate(35.04 69.943)",
    fill: "#ffde9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8245",
    "data-name": "Rectangle 8245",
    width: 4.825,
    height: 7.172,
    rx: 2.412,
    transform: "translate(35.04 104.13)",
    fill: "#ffde9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_26",
    "data-name": "Subtraction 26",
    d: "M140.777,132.777H0V0H140.777ZM70.12,8.566c-33.656,0-61.037,25.825-61.037,57.569S36.464,123.7,70.12,123.7s61.037-25.825,61.037-57.568S103.776,8.566,70.12,8.566Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14176",
    "data-name": "Group 14176",
    transform: "translate(409.787 734.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11222",
    "data-name": "Group 11222",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7418",
    "data-name": "Path 7418",
    d: "M19.583.5A19.083,19.083,0,1,1,.5,19.583,19.083,19.083,0,0,1,19.583.5Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#07a3c8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun_894526_cc",
    transform: "translate(419.605 745.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14177",
    "data-name": "Group 14177",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9306",
    "data-name": "Path 9306",
    d: "M23.148,968.676a5.335,5.335,0,0,1,1.341,5.292l7.638,7.637.18,3.412L28,984.658V982.5H25.842v-2.155H23.687L20.9,977.559a5.333,5.333,0,1,1,2.25-8.883ZM19.2,970.112a1.524,1.524,0,1,0,0,2.155A1.524,1.524,0,0,0,19.2,970.112Z",
    transform: "translate(-14.044 -967.113)",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pinLock.918fe8d2.svg";
export { ForwardRef as ReactComponent };